import ApplicationType from "enums/ApplicationType";
import type { BankAccount } from "hooks/useGetBankAccounts";

/** A charge program is repaid by statement, never funded or drawn from. */
export const movesFunds = (account: BankAccount): boolean =>
  account.applicationType !== ApplicationType.CHARGE;

/** An issuer moves money only with banks linked on its own connection. */
export const banksOnConnection = (
  banks: BankAccount[],
  program?: BankAccount,
): BankAccount[] =>
  program?.connectionId
    ? banks.filter((bank) => bank.connectionId === program.connectionId)
    : banks;

/** The pick still on offer, else the preferred one, else the first. */
export const keepOrPick = (
  options: BankAccount[],
  current: string,
  preferredId?: string,
): string => {
  if (options.some(({ id }) => id === current)) return current;
  const preferred = options.find(({ id }) => id === preferredId);
  return (preferred ?? options[0])?.id ?? "";
};
